import { Storybook } from "@tento-ui/ui/storybook";
import { Button } from "@tento-ui/components/button/button";
import { NaiveDate } from "@tento-chrono";
import { DebugMetadataPanel } from "./debug-metadata-panel";

export class DebugMetadataPanelStoryBook extends Storybook.Default {
  title(): string {
    return "Debug Metadata Panel";
  }

  examples(): Storybook.Example[] {
    return [
      {
        title: "With Sync Duration (Syncing)",
        render: () => {
          return DebugMetadataPanel.make().bind({
            dateRange: {
              start: NaiveDate.fromYmd1Exp(2024, 1, 1),
              end: NaiveDate.fromYmd1Exp(2024, 1, 31),
            },
            showSyncDuration: true,
          });
        },
      },
      {
        title: "Without Sync Duration",
        render: () => {
          return DebugMetadataPanel.make().bind({
            dateRange: {
              start: NaiveDate.fromYmd1Exp(2024, 6, 1),
              end: NaiveDate.fromYmd1Exp(2024, 6, 30),
            },
            showSyncDuration: false,
          });
        },
      },
      {
        title: "Sync Complete (Interactive)",
        render: () => {
          const $panel = DebugMetadataPanel.make().bind({
            dateRange: {
              start: NaiveDate.fromYmd1Exp(2024, 3, 15),
              end: NaiveDate.fromYmd1Exp(2024, 4, 15),
            },
            showSyncDuration: true,
          });

          const $controls = Storybook.Card.Controls.make();
          const $button = Button.makeWith("Simulate Sync Complete", {
            type: "primary",
            onClick: () => {
              $panel.updateSyncDuration(1234);
            },
          });
          $controls.appendChild($button);

          return {
            $content: $panel,
            $controls,
          };
        },
      },
    ];
  }
}
